<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="warning"
        dark
        v-bind="attrs"
        v-on="on"
      >
        Прикрепить экзаменационное расписание
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Прикрепить экзаменационное расписание</span>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="select"
          item-text="value"
          item-value="key"
          :items="items"
          label="Выберите номер экзамена"
        ></v-select>
      </v-card-text>
      <ValidationObserver ref="observer">
        <v-card-text>
          <ValidationProvider
            v-slot="{ errors }"
            name="protector"
            rules="required_protector_reject"
          >
            <v-select
              v-model="select_protector"
              item-text="full_name"
              item-value="id"
              :items="protectors"
              label="Выберите протектора"
              :error-messages="errors"
            ></v-select>
          </ValidationProvider>
        </v-card-text>
      </ValidationObserver>
      <v-card-text>
        <file-input
          ref="typeFiles"
          :multiple=true
          :type="select"
          :application="application">
        </file-input>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text v-on:click="submit">Отправить</v-btn>
        <v-btn color="red darken-1" text @click="dialog = false">Закрыть</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FileInput from "../profile/FileInput";
import {mapGetters} from 'vuex';
import Vue from 'vue'
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";

export default {
  name: "send_blank_exam",
  data: () => ({
    dialog: false,
    isSuccess: false,
    select: 150,
    test: null,
    items: [
      {key: 150, value: 'Экзамен № 1'},
      {key: 151, value: 'Экзамен № 2'},
      {key: 152, value: 'Экзамен № 3'},
    ],
  }),
  props: ['application'],
  components: {
    FileInput,
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    this.$store.dispatch('operator/loadProtectorCheck', {exam: this.select, application: this.application.id});
    this.$store.dispatch('operator/loadProtector')
  },
  computed: {
    ...mapGetters("operator", ["protectors"]),
    ...mapGetters("operator", ["protectors_check"]),
    select_protector: {
      get() {
        return this.protectors_check.protector
      },
      set(value) {
        this.test = value
      }
    },
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.$store.dispatch("filemanager/loadUploadedFilesByApplication", this.application.id);
      }
    },
    select(newValue) {
      if (newValue) {
        this.$store.dispatch("filemanager/loadUploadedFilesByApplication", this.application.id);
        this.$store.dispatch("operator/loadProtectorCheck", {exam: newValue, application: this.application.id})
      }
    },
  },
  methods: {
    async submit() {
      await this.$refs.observer.validate().then(success => {
        if (!success) {
          return;
        }
        this.dialog = false;
        Vue.axios.post('operator/protector_save/', {
          protector: this.test,
          application: this.application.id,
          exam: this.select
        })
          .then(function () {
            console.log('SUCCESS!!');
          })
          .catch(function () {
            console.log('FAILURE!!');
          });
      })
    }
  },
}

extend('required_protector_reject', {
  ...required,
  message: 'Поле "Протектор" Не должно быть пустым',
});
</script>

<style scoped>

</style>
